(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search-autocomplete"]) return;
  try {
    
$(function() {
  var currentAjaxRequest = null;
  
  var searchForms = $('form[action="/search"]').css('position','relative').each(function() {
    var input = $(this).find('input[name="q"]');

    $('<ul class="search-results"></ul>').appendTo($(this)).hide();    
    
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      
      var term = $(this).val();
      var form = $(this).closest('form');
      var searchURL = '/search?type=product&q=' + term;
      var resultsList = form.find('.search-results');

      if (term.length > 2 && term != $(this).attr('data-old-term')) {
        
        $(this).attr('data-old-term', term);
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
          console.log("Data results:", data.results);
          resultsList.empty();
          
          if(data.results_count == 0) {
            resultsList.html('<li><span class="title">No results.</span></li>');
			resultsList.addClass('search-no-result');
            //resultsList.fadeIn(200);
            //resultsList.hide();
          } else {
			resultsList.removeClass('search-no-result');
            $.each(data.results, function(index, item) {
              var link = $('<a class="clearfix"></a>').attr('href', item.url);
              link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
              link.append('<span class="title">' + item.title + '<span class="price">' + item.price + '</span> </span>');
              link.wrap('<li></li>');
              resultsList.append(link.parent());
            });
            
            if(data.results_count > 4) {
              resultsList.append('<li><span class="title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
            }
            resultsList.fadeIn(200);
          }        
        });
      }
    });
  });
  
  // Clicking outside makes the results disappear.
  $('body').bind('click', function(){
    $('.search-results').hide();
  });
});

  } catch(e) { console.error(e); }
})();
})();
